import { create } from 'zustand';
import { ru } from './ru';
import { en } from './en';
import type { Translations } from './ru';

export type Lang = 'ru' | 'en';

const TRANSLATIONS: Record<Lang, Translations> = { ru, en };

interface I18nStore {
  lang: Lang;
  setLang: (l: Lang) => void;
}

const savedLang = (typeof localStorage !== 'undefined' ? localStorage.getItem('lang') : null) as Lang | null;

export const useI18nStore = create<I18nStore>((set) => ({
  lang: savedLang ?? 'ru',
  setLang: (lang) => {
    if (typeof localStorage !== 'undefined') localStorage.setItem('lang', lang);
    set({ lang });
  },
}));

function get(obj: unknown, key: string): string {
  const parts = key.split('.');
  let cur = obj;
  for (const part of parts) {
    if (cur && typeof cur === 'object') {
      cur = (cur as Record<string, unknown>)[part];
    } else {
      return key;
    }
  }
  return typeof cur === 'string' ? cur : key;
}

export function useT() {
  const lang = useI18nStore((s) => s.lang);
  const dict = TRANSLATIONS[lang];

  return (key: string, vars?: Record<string, string | number>): string => {
    let str = get(dict, key);
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        str = str.split(`{{${k}}}`).join(String(v));
      }
    }
    return str;
  };
}
